<template>
  <div class="root">
    <div class="layer">
      <van-list>
        <span v-for="item in contentList" :key="item">
          <van-image v-if="!isVideo(item)" :src="item" />
          <video
          v-if="isVideo(item)"
          id="myVideo"
          controls
          poster="https://imgs.youchalian.com/283679041330925230.jpg"
          autoplay
          :src="item"
          class="video-js vjs-default-skin vjs-big-play-centered "
          style="width:100%;height:100%;object-fit: fill"
        >
        </video>
        </span>
      </van-list>
    </div>
    <div
      :style="{
        color: poster.color,
        backgroundColor: poster.bgColor
      }"
    >
      <van-form validate-first @failed="onFailed" @submit="onSubmit">
        <!-- 通过 pattern 进行正则校验 -->
        <van-cell-group title="姓名">
          <van-field
            v-model="username"
            required
            name="name"
            placeholder="请输入姓名"
            scroll-to-error
            clearable
            :error="false"
            :maxlength="5"
            :rules="[
              {
                message: '姓名不能为空',
                required: true
              }
            ]"
          />
        </van-cell-group>
        <van-cell-group title="手机号">
          <van-field
            v-model="mobile"
            name="mobile"
            required
            type="number"
            placeholder="请输入手机号码"
            clearable
            :error="false"
            :rules="[
              {
                pattern: mobilePattern,
                message: '手机号码格式错误',
                required: true
              }
            ]"
          />
          <van-field
            v-model="validateCode"
            name="validateCode"
            placeholder="请输入校验码"
            clearable
            :rules="[
              {
                required: true
              }
            ]"
          >
            <div slot="button">
              <van-image
                @click="toggleCode"
                width="80"
                :src="verificationImg"
              />
            </div>
          </van-field>
          <van-field
            v-model="smsCode"
            :rules="[
              {
                message: '短信校验码不能为空!',
                required: true
              }
            ]"
            clearable
            name="smsCode"
            placeholder="请输入验证码"
          >
            <div slot="button">
              <div v-if="showCountDown">
                <van-count-down
                  :time="smsTime"
                  format="ss"
                  @finish="countDownFinish"
                />
              </div>
              <div v-else class="smsCodeText" v-on:click="sendSmsCode">
                获取验证码
              </div>
            </div>
          </van-field>
        </van-cell-group>

        <van-cell-group title="意向加盟城市">
          <input v-model="provice" name="provice" type="hidden" />
          <input v-model="city" name="city" type="hidden" />
          <input v-model="area" name="area" type="hidden" />

          <van-field
            v-model="areas"
            is-link
            readonly
            name="address"
            placeholder="地区选择"
            @click="showArea = true"
          />
          <van-popup v-model="showArea" position="bottom">
            <van-area
              :area-list="areaList"
              @confirm="onConfirm"
              @cancel="showArea = false"
            />
          </van-popup>
        </van-cell-group>
        <span style="font-size: 12px;">
          <van-checkbox
            icon-size="15px"
            v-model="inputChecked"
            shape="square"
            style="margin: 5px;"
            >保存手机号,下次自动填写《<span
              @click="showInput = !showInput"
              style="color: blue; "
              >自动填写信息授权书</span
            >》</van-checkbox
          >
          <van-checkbox
            icon-size="15px"
            v-model="privacyChecked"
            shape="square"
            style="margin: 5px;"
            >我已阅读同意《<span
              @click="showPrivacy = !showPrivacy"
              style="color: blue;"
              >个人信息与隐私保护条款</span
            >》</van-checkbox
          >
        </span>
        <!-- 按钮 -->
        <div class="btn-wrap">
          <van-button
            :disabled="btnFlag"
            block
            type="primary"
            native-type="submit"
            :style="{
              color: poster.color,
              backgroundColor: poster.btnColor
            }"
            >立即报名</van-button
          >
        </div>
      </van-form>
    </div>
    <van-action-sheet
      cancel-text="关闭"
      close-on-click-action
      v-model="showInput"
      title="自动填写信息授权书"
    >
      <div
        style="margin: 16px;max-height: 300px;overflow:auto;"
        v-html="poster.certificate"
      ></div>
    </van-action-sheet>
    <van-action-sheet
      v-model="showPrivacy"
      cancel-text="关闭"
      close-on-click-action
      title="个人信息与隐私保护条款"
    >
      <div
        style="margin: 16px;max-height: 300px;overflow:auto;"
        v-html="poster.privacy"
      ></div>
    </van-action-sheet>
    <div class="tel">
      <a :href="'tel:' + poster.phone"><van-icon name="phone"/></a>
    </div>
  </div>
</template>

<script>
import { queryPost, apiPost } from "@/api/common";
import { areaList } from "@vant/area-data";
import { verificationCode, sendSmsCode } from "@/api/user";
import { Toast } from "vant";
import { ref } from "vue";
export default {
  metaInfo: {
    title: "招商加盟",
    meta: [
      { charset: "utf-8" },
      {
        name: "viewport",
        content:
          "width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no"
      }
    ]
  },

  data() {
    return {
      poster: "",
      contentList: [],
      showArea: false,
      areaList,
      areaName: "",
      form: {},
      areas: "",
      smsCode: "",
      smsTime: 60 * 1000,
      checked: false,
      showCountDown: false, //是否显示倒计时
      maxDiffTime: 60 * 1000, // 发送短信的间隔,
      verificationImg: "",
      validateCode: "",
      mobilePattern: /^[1]([3-9])[0-9]{9}$/, //正则匹配手机号码
      mobile: "",
      username: "",
      inputChecked: false,
      showInput: false,
      privacyChecked: false,
      showPrivacy: false,
      provice: "",
      city: "",
      area: "",
      btnFlag: false
    };
  },
  setup() {
    const result = ref("");
    const showArea = ref(false);
    const onConfirm = areaValues => {
      showArea.value = false;
      result.value = areaValues
        .filter(item => !!item)
        .map(item => item.name)
        .join("/");
    };

    return {
      result,
      areaList,
      showArea,
      onConfirm
    };
  },
  watch: {},
  created() {
    let that = this;
    this.loadComments();
    const url = window.location.href;

    const params = url.split("?");
    let id = 0;
    if (params.length > 1) {
      id = params[1];
    }
    const apiUrl = "/market/attract/getDetailById";
    queryPost(apiUrl, { id: id }).then(res => {
      if (res.data.code == "0000") {
        let result = res.data.data.results;
        that.poster = result;
        that.contentList = result.content.split(",");
        document.title = result.name;
      }
    });
  },
  methods: {
    isVideo(src) {

      src = src.toLowerCase();
      const r = src.endsWith("mp4");
      console.log(r)
      return r;
    },
    loadComments() {
      let _this = this;
      var num = Math.ceil(Math.random() * 1000);
      _this.verificationImg = "/mem/verificationCode/validateCode?" + num;

      _this.getCountDownTime();
    },
    onConfirm(e) {
      this.showArea = false;
      let _this = this;
      e.forEach((item, index) => {
        _this.areas += item.name + " ";

        if (index == 0) {
          _this.provice = item.name;
        }
        if (index == 1) {
          _this.city = item.name;
        }
        if (index == 2) {
          _this.area = item.name;
        }
      });
      // this.fomr.provice=e[0].
    },
    onFailed(e) {
      console.log(e);
    },
    onSubmit(e) {
      let _this = this;
      if (!_this.privacyChecked) {
        Toast.fail("请勾选我已阅读并同意 个人信息与隐私保护条款");
        return;
      }
      const apiUrl = "/market/preJoin/add";
      e.provice = this.provice;
      e.city = this.city;
      e.area = this.area;
      _this.btnFlag = true;
      apiPost(apiUrl, e).then(res => {
        _this.btnFlag = false;
        if (res.data.code == "0000") {
          Toast.success("报名成功");
          _this.init();
        } else {
          Toast.fail(res.data.msg);
        }
      });
      console.log(e);
    },
    init() {
      this.areas = "";
      this.mobile = "";
      this.username = "";
      this.provice = "";
      this.city = "";
      this.area = "";
      this.validateCode = "";
      this.smsCode = "";
    },
    //获取时间倒计时
    getCountDownTime() {
      let _this = this;
      let st = sessionStorage.getItem("sendTime");
      let sendTime = st ? parseInt(st) : 0;
      const diffTime = new Date().getTime() - sendTime;
      if (diffTime >= this.maxDiffTime) {
        _this.showCountDown = false;
      } else {
        _this.smsTime = _this.smsTime - diffTime;
        _this.showCountDown = true;
      }
    },
    //点击验证码
    toggleCode() {
      var num = Math.ceil(Math.random() * 1000); //生成一个随机数（防止缓存）
      this.verificationImg = "/mem/verificationCode/validateCode?" + num;
    },
    //改变计时状态
    countDownFinish() {
      this.showCountDown = false;
    },
    //发送短信验证码
    sendSmsCode() {
      let _this = this;
      verificationCode(_this.validateCode).then(resp => {
        if (resp.data.code == 200) {
          sendSmsCode(_this.mobile, 97);
          _this.showCountDown = true;
        } else {
          Toast("图形验证码错误！");
        }
      });
      sessionStorage.setItem("sendTime", new Date().getTime());
    }
  }
};
</script>
<style lang="less" scoped>
.van-image {
  display: block;
}
.root {
  padding-bottom: 0rem;
  padding-top: 0px;

  background-size: cover;
  background-repeat: repeat;
  background-position: 50% 0px;
  min-height: 100%;
  box-sizing: border-box;
  .layer {
    margin: 0 auto;
    .form {
      display: flex;
      flex-direction: column;
      padding: 0px;
    }
  }
}

.tel {
  background-color: #d8caca;
  overflow: hidden;
  z-index: 9999;
  position: fixed; /*DIV悬浮(固定位置)*/
  padding: 5px;
  text-align: center;
  width: 50px;
  height: 50px;
  font-size: 45px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-radius: 50%;
  right: 10px;
  bottom: 50px;
}
</style>
